import type { UiConfigOverlay } from "@repo/ui-config";

import type { PlatformApiTrpcClient } from "~/lib/trpc/platform-api-adapter";
import { startUserAction } from "~/lib/user-action-observer";

import type { UiConfigSyncClient } from "./server-sync";

/** Adapts the platform-api tRPC client to the sync controller's port. */
export function createUiConfigTrpcSyncClient(
  platformApi: PlatformApiTrpcClient,
): UiConfigSyncClient {
  return {
    async get() {
      const result = await platformApi.uiConfig.get.query();
      return {
        document: result.document as UiConfigOverlay,
        revision: result.revision,
      };
    },
    async set(input) {
      const userAction = startUserAction({
        action: "ui_config.sync",
        surface: "app_shell",
      });
      try {
        const result = await platformApi.uiConfig.set.mutate({
          document: input.document,
          expectedRevision: input.expectedRevision,
        });
        userAction.succeed();
        return { revision: result.revision };
      } catch (error) {
        userAction.fail(error);
        throw error;
      }
    },
    isRevisionConflict(error) {
      if (typeof error !== "object" || error === null) {
        return false;
      }
      const data = (error as { data?: unknown }).data;
      return (
        typeof data === "object" &&
        data !== null &&
        (data as { code?: unknown }).code === "CONFLICT"
      );
    },
  };
}
